import React, { PropTypes, cloneElement } from 'react';
import { Popover, Menu, List } from 'material-ui';
import R from 'ramda';

const propTypes = {
  children: PropTypes.any,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  buttonStyleProps: PropTypes.object,
  button: PropTypes.node,
  menuProps: PropTypes.object,
  useList: PropTypes.bool,
};

class FlatDropDownMenu extends React.Component {
  constructor() {
    super();
    this.state = { menuOpen: false };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }

  handleButtonClick = (e) => {
    if (e) this.setState({ menuOpen: true, anchorEl: e.currentTarget });
  };

  dismissMenu = () => {
    this.setState({ menuOpen: false });
  }

  render() {
    const { button, menuProps = {}, useList, children } = this.props;
    const { menuOpen, anchorEl } = this.state;
    return (
      <div>
        {cloneElement(button, { onTouchTap: this.handleButtonClick, onClick: this.handleButtonClick })}
        <Popover
          open={menuOpen}
          onRequestClose={this.dismissMenu}
          anchorEl={anchorEl}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        >
          {
            useList ? (
              <List
                onClick={this.dismissLis}
                {...menuProps}
              >
                {children}
              </List>
            ) : (
              <Menu
                onItemTouchTap={this.dismissMenu}
                desktop
                {...menuProps}
              >
                {children}
              </Menu>
            )
          }
        </Popover>
      </div>
    );
  }
}
FlatDropDownMenu.propTypes = propTypes;
export default FlatDropDownMenu;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/flatDropDownMenu.jsx